<template>
  <v-col cols="12">
    <v-alert
      v-if="isAlert"
      border="left"
      :type="alertType.type"
      :class="alertType.classes"
      :icon="alertType.icon"
    >
      <survey-question-text :text="question.text"></survey-question-text>
    </v-alert>
    <div v-else :class="textClasses" class="mb-4 questionText d-flex align-start">
      <survey-question-text
        :text="question.text"
      ></survey-question-text>
    </div>
  </v-col>
</template>

<style lang="scss">
.questionText {
  font-size: 1.1rem;
}
</style>

<script>
import Vue from "vue";
import {
  showQuestion,
  getQuestionHTML,
  getQuestionTextParts,
  questionTextPartType,
  getQuestionSetting,
  questionSettings,
  getAlertType,
} from "../constants/Survey";

import SurveyQuestionText from "./Survey.Question.Text.vue";

export default {
  name: "SurveyQuestionTextBlock",
  components: {
    SurveyQuestionText,
  },
  data: () => ({
    innerValue: [],
  }),
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    question: {
      type: Object,
    },
    textClasses: {
      type: String,
      default: "",
    },
  },
  computed: {
    isAlert() {
      return (
        getQuestionSetting(this.question.settings, questionSettings.isAlert.key)
          .value == "true"
      );
    },
    alertType() {
      var key = getQuestionSetting(
        this.question.settings,
        questionSettings.alertType.key
      ).value;

      return getAlertType(key);
    },
    fieldValue() {
      let target = this.innerValue.find((y) => y.key === this.question.key);
      return target ? target.value : null;
    },
    visible() {
      return showQuestion(this.question, this.innerValue);
    },
    questionHTML() {
      return getQuestionHTML(this.question.text);
    },
    questionTextParts() {
      return getQuestionTextParts(this.question.text);
    },
    questionTextPartType() {
      return questionTextPartType;
    },
    answer() {
      return this.innerValue.find((x) => x.key === this.question.key)?.value;
    },
    isValid() {
      return true;
    },
    errors() {
      let result = [];

      return result;
    },
  },
  watch: {
    value(val) {
      if (!keyPairArraysAreEqual(val, this.innerValue)) {
        this.innerValue = val;
      }
    },
    innerValue(value, prev) {
      if (!keyPairArraysAreEqual(value, prev)) {
        this.$emit("input", this.innerValue);
      }
    },
  },
  methods: {
    stopper(e) {
      if (e.code != "Backspace" && e.target.value.length > this.maxLength)
        e.target.value = e.target.value.slice(0, this.maxLength - 1);
    },
    setAnswer(value) {
      if (value?.length > this.maxLength - 1) {
        value = value.slice(0, this.maxLength - 1);
      }

      let keyPair = { key: this.question.key, value };
      let index = this.innerValue.findIndex((x) => x.key === this.question.key);
      if (index > -1) Vue.set(this.innerValue, index, keyPair);
      else this.innerValue.push(keyPair);
    },
    validate() {
      return this.isValid;
    },
    reset() {
      return;
    },
  },
  mounted() {
    if (this.value) this.innerValue = this.value;
  },
  destroyed() {
    // Clear answer if hidden.
    if (!showQuestion(this.question, this.innerValue)) this.setAnswer(null);
  },
};

function keyPairArraysAreEqual(a, b) {
  return flatten(a) === flatten(b);

  function flatten(arr) {
    return JSON.parse(JSON.stringify(arr));
  }
}
</script>
